const initialState: sage.state.IUser = {
    accessToken: null,
    loadTokenStatus: "loading",
    fetchUserStatus: "none",
    loginStatus: "none",
    user: null,
    signUpStatus: "none",
    stripeAccountLink: undefined,
    stripeAccountLinkStatus: "loading",
    resetPasswordStatus: "none",
    sendResetPasswordStatus: "none",
    submitFeedbackStatus: "none",
};

export default function user(
    state: sage.state.IUser = initialState,
    action: sage.actions.user.ReducerTypes
): sage.state.IUser {
    switch (action.type) {
        case "com.sage.actions.user.IClear":
            return {
                ...initialState,
                loadTokenStatus: "none",
            };
        case "com.sage.actions.user.ISetAccessToken":
            return {
                ...state,
                accessToken: action.accessToken,
            };
        case "com.sage.actions.user.ISetLoadTokenStatus":
            return {
                ...state,
                loadTokenStatus: action.status,
            };
        case "com.saga.actions.user.ISetLoginStatus":
            return {
                ...state,
                loginStatus: action.status,
            };
        case "com.sage.actions.jobs.ISetUser":
            return {
                ...state,
                user: action.user,
            };
        case "com.sage.actions.user.ISetFetchUserStatus":
            return {
                ...state,
                fetchUserStatus: action.status,
            };
        case "com.sage.actions.user.ISetSignUpStatus":
            return {
                ...state,
                signUpStatus: action.status,
            };
        case "com.sage.actions.user.ISetStripeAccountLinks":
            return {
                ...state,
                stripeAccountLink: action.accountLinks,
            };
        case "com.sage.actions.user.ISetStripeAccountLinksStatus":
            return {
                ...state,
                stripeAccountLinkStatus: action.status,
            };
        case "com.sage.actions.user.ISetSendResetPasswordStatus":
            return {
                ...state,
                sendResetPasswordStatus: action.status,
            };
        case "com.sage.actions.user.ISetResetPasswordStatus":
            return {
                ...state,
                resetPasswordStatus: action.status,
            };
        case "com.sage.actions.users.ISetSubmitFeedbackStatus":
            return {
                ...state,
                submitFeedbackStatus: action.status,
            };
        default:
            return state;
    }
}
